module.exports = __webpack_public_path__ + "img/prestamo-autocompras.6b0f8bfa.webp";